import { useState, useEffect } from 'react';
import {
    addProfilePost,
    updateProfile,
    getProfileByIdUser
} from '../services/ProfileService';

export const useProfile = () => {

    const [profile, setProfile] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const addProfile = async (product) => {
        try {
            const response = await addProfilePost(product);
            setProfile([...profile, response.data]);
        } catch {
            setError('Failed to add product');
        }
    };

    const editProfile = async (id, updatedProduct) => {
        try {
            const response = await updateProfile(id, updatedProduct);
            setProfile(profile.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update product');
        }
    };

    const fetchProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfileByIdUser();
            setProfile(response.data);

            setLoading(false);
        } catch (err) {
            setError('Failed to fetch products');
            setLoading(false);
        } finally {
            setLoading(false);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchProfile()
    }, []);

    return {
        loading,
        error,
        fetchProfile,
        addProfile,
        editProfile,
        profile
    }

};